(function ($) {
	pep.server.shouldSubmitDisabledFields = true;
	// Applies a slow Show or Hide animation to the jQuery selection set
	$.fn.slowToggle = function (value) {
		if (value) $(this).show("slow"); else $(this).hide("slow");
		return $(this);
	};
	$.fn.slowToggleWithCallback = function (value, callback) {
		if (value) $(this).show("slow", callback); else $(this).hide("slow", callback);
		return $(this);
	};
	$.fn.setVisible = function (value) {
		if (value) $(this).show(); else $(this).hide();
		return $(this);
	};

	$.fn.slideShift = function (value) {
	    if (value) $(this).slideDown("slow"); else $(this).slideUp("slow");
	    return $(this);
	};

	$.fn.fadeAndSlide = function (value) {
	    if (value) {
	        $(this)
              .css('opacity', 0)
              .slideDown('slow')
              .animate(
                { opacity: 1 },
                  { queue: false, duration: 'slow' }
              );
	    }
	    else {
	        $(this)
              .css('opacity', 1)
              .slideUp('slow')
              .animate(
                { opacity: 0 },
                { queue: false, duration: 'slow' }
              );
	    }
	};
	$.fn.isYesVal = function () {
		return ($(this).val() == "Y");
	};

	// Sets all elements in a jQuery selection set to required or not
	$.fn.setRequired = function (isRequired, message) {
		$(this).each(function () { pep.controls.setRequired($(this), isRequired, message); });
		return $(this);
	};

	$.fn.setEnabled = function (enabled) {
		$(this).each(function () { pep.controls.setEnabled($(this), enabled); });
		return $(this);
	};

	$.fn.getEnabled = function () {
		return !$(this).attr('disabled');
	};

	$.fn.addWatermarks = function (text) {
		if (text === undefined) text = 'Optional';
		if (!$(this).attr('disabled')) {
			$(this).watermark(text, { className: 'purchaseWatermark', useNative: false });
        }
        return $(this);
	};
	$.fn.illegalCharStrip = function () {
		$(this).each(function () {
			$(this).val($(this).val().replace(/[!#<>&\*\$=\^%]/g, ''));
		});
	};
})(jQuery);

function addCommas(nStr) {
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

function addNumberSuffix(i) {
    var a = i % 10;
    var b = i % 100;

    if (a === 1 && b !== 11) {
        return i + "st";
    } else if (a === 2 && b !== 12) {
        return i + "nd";
    } else if (a === 3 && b !== 13) {
        return i + "rd";
    } else {
        return i + "th";
    }
}

var formatMoney = function (floatVal) {
    var prefix = '';

    if (floatVal < 0) {
        prefix = '- '
    }

    return prefix + '$' + addCommas(Math.abs(floatVal).toFixed(2)).toString();
};